import { render } from "./LinkForm.vue?vue&type=template&id=47709f7e&ts=true"
import script from "./LinkForm.vue?vue&type=script&lang=ts"
export * from "./LinkForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__